import { useQueryClient, useMutation } from '@tanstack/react-query';
import { DeleteControlDto } from '@ansvar-sakerhet/api-client';
import { useApi } from '../useApi';
import { toast } from '../../../components/Toast';
import { controlKeys } from './controls.key';

type Options = {
  onDeleteControlSuccess?: () => void;
  onDeleteControlError?: (error: unknown) => void;
};

type DeleteControlArgs = {
  controlId: string;
  inspectionId: string;
};

export function useDeleteControl(options?: Options) {
  const getApi = useApi();
  const queryClient = useQueryClient();

  const deleteControl = async ({ controlId, inspectionId }: DeleteControlArgs) => {
    const api = await getApi();
    const body: DeleteControlDto = { inspectionId };
    const res = await api.controlsDelete(controlId, body);
    return res.data;
  };

  const onSuccess = () => {
    toast.success('Kontrollen har raderats');
    queryClient.invalidateQueries({ queryKey: controlKeys.all });
    options?.onDeleteControlSuccess?.();
  };

  const onError = (error: unknown) => {
    toast.error('Kontrollen gick inte att radera');
    options?.onDeleteControlError?.(error);
  };

  return useMutation(deleteControl, {
    onSuccess,
    onError,
  });
}
